<template>
    <tr class="job-offers__head-row">
        <th class="job-offers__head-item">
            <div class="job-offers__head-container">
                {{ translation_position }}
            </div>
        </th>
        <th class="job-offers__head-item">
            <div class="job-offers__head-container">
                <select
                    class="job-offers__head-dropdown"
                    :value="department"
                    @change="set_department($event.currentTarget.value)"
                >
                    <option value="" class="job-offers__head-dropdown-item">
                        {{ translation_departments }}
                    </option>
                    <option
                        v-for="(department, index) in getDepartments"
                        :key="index"
                        :value="department"
                    >
                        {{ department }}
                    </option>
                </select>
            </div>
        </th>
        <th class="job-offers__head-item">
            <div class="job-offers__head-container">
                <select
                    class="job-offers__head-dropdown"
                    :value="office"
                    @change="set_office($event.currentTarget.value)"
                >
                    <option value="" class="job-offers__head-dropdown-item">
                        {{ translation_offices }}
                    </option>
                    <option
                        v-for="(office, index) in getOffices"
                        :key="index"
                        :value="office"
                    >
                        {{ office }}
                    </option>
                </select>
            </div>
        </th>
        <th class="job-offers__head-item--invisible"></th>
        <th class="job-offers__head-item job-offers__head-item-search">
            <div
                class="job-offers__search"
                :class="isBarVisible ? 'job-offers__search--active' : ' '"
                @click="showSearchBar"
            >
                <p>Search</p>
                <input
                    type="text"
                    autofocus
                    ref="searchInput"
                    class="job-offers__search-bar"
                    :class="
                        isBarVisible ? 'job-offers__search-bar--active' : ' '
                    "
                    @keyup="search"
                />
            </div>
        </th>
    </tr>
</template>

<script>
import _, { debounce } from "lodash";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
export default {
    props: [
        "translation_departments",
        "translation_offices",
        "translation_position"
    ],
    data() {
        return {
            isBarVisible: false,
            offices: [],
            departments: []
        };
    },

    methods: {
        ...mapMutations(["set_office", "set_department", "set_search_query"]),
        ...mapActions([]),
        showSearchBar(event) {
            if (event.target.classList.contains("job-offers__search-bar"))
                return;
            this.isBarVisible = !this.isBarVisible;
            this.$nextTick(() => this.$refs.searchInput.focus());
        },

        search: debounce(function() {
            let query = this.$refs.searchInput.value;

            this.set_search_query(query);
        }, 800)
    },
    computed: {
        ...mapGetters(["getOffices", "getDepartments", "get_office"]),
        ...mapState(["office", "department", "search_query"])
    }
};
</script>
